import './app.component.imports';
import { Component, effect, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AppShellStore } from './app-shell.store';
import { AuthService } from './authentication/auth.service';
import { IToolbar, IToolbarItem } from '@vestasregistry/ui-component-library';
import { STANDALONE_COMPONENT_IMPORTS } from './shared/standalone-component-imports';
import { MsalModule } from '@azure/msal-angular';
import { GlobalNotificationsComponent } from './shared/global-notifications/global-notifications.component';
import { MapSettingsComponent } from './shared/map-settings/map-settings.component';
import { ConfirmationDialogueComponent } from './shared/confirmation-dialogue/confirmation-dialogue.component';
import { PlacemarkComponent } from './shared/placemark/placemark.component';
import { UserProfileModalComponent } from './shared/user-profile-modal/user-profile-modal.component';

@Component({
    standalone: true,
    imports: [
        RouterOutlet,
        MsalModule,
        MapSettingsComponent,
        ConfirmationDialogueComponent,
        PlacemarkComponent,
        UserProfileModalComponent,
        GlobalNotificationsComponent,
        ...STANDALONE_COMPONENT_IMPORTS,
    ],
    selector: 'pd-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit {
    private readonly shellStore = inject(AppShellStore);
    public readonly featureFlagsLoaded = this.shellStore.featureFlagsLoaded;
    public readonly featureFlagsLoading = this.shellStore.featureFlagsLoading;
    public readonly environmentName = this.shellStore.environmentName;
    private readonly hasAccess = this.shellStore.hasAccess;
    public readonly featureFlags = this.shellStore.featureFlags;
    
    private readonly user = this.shellStore.user;

    public toolbar: IToolbar;
    public showUserProfileDialogue: boolean;

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
    ) {
        effect(() => {
            const user = this.user();
            if (user) {
                this.handleUser(user);
            }
        });
        effect(() => {
            const hasAccess = this.hasAccess();
            if (!hasAccess) {
                this.navigateToNoAccess();
            }
        });
    }

    ngOnInit() {
        this.authService.initAuthentication();
    }

    private handleUser(user: PlantDesign.UI.IUser): void {
        const isPopOut = this.shellStore.isPopOutWindow();
        if (user && !isPopOut) {
            this.setToolbar(user.displayName);
        }
    }

    private signOut(): void {
        this.authService.signOut();
        this.shellStore.signOut();
    }

    public titleClick(): void {
        this.router.navigate(['/']);
    }

    private navigateToNoAccess(): void {
        this.router.navigate(['/no-access']);
    }

    public closeUserProfileDialogue(): void {
        this.showUserProfileDialogue = false;
    }

    // Toolbar
    
    private setToolbar(userName: string): void {
        const items: IToolbarItem[] = [
            {
                title: 'Report PlantDesign Incident',
                onClick: () => {
                    globalThis.window.open('https://vestasprod.service-now.com/itservice?id=reflect_sc_cat_item&sys_id=54264dc81b9dfc1000efa8ade54bcb1d', '_blank');
                }
            },
            {
                title: 'Log out',
                onClick: () => {
                    this.signOut();
                },
            },
            {
                title: 'User profile',
                onClick: () => {
                    this.showUserProfileDialogue = true;
                }
            }
        ];
        this.toolbar = {
            title: userName,
            items,
        };
    }

}
